<div
  *ngIf="!disabled"
  [class.error]="mandatory && _values.length === 0"
  [ngClass]="classWidth"
  class="element">
  <div class="header">
    <div class="label">
      {{ label + (mandatory ? ' *' : '') }}
      <eop-icon
        *ngIf="infoText"
        [color]="infoTextColor ? infoTextColor : IconColor.NORMAL"
        [identifier]="'info-circle-filled'"
        [size]="IconSize.SMALL"
        [tooltip]="infoText"
        [vaylensFont]="true"
        class="icon">
      </eop-icon>
      <eop-chip
        *ngIf="headerChipValue"
        [chipColor]="headerChipColor"
        [emphasized]="false"
        [matTooltipPosition]="'right'"
        [matTooltip]="headerChipTooltipText"
        [text]="headerChipValue"
        [class.clickable]="headerChipClickable"
        (click)="onChipClick()">
      </eop-chip>
    </div>
  </div>
  <div [ngClass]="{ 'wrap-lines': breakLines }" class="form-element-content">
    <div *ngIf="contentTemplate">
      <ng-container *ngTemplateOutlet="contentTemplate"> </ng-container>
    </div>
    <div *ngIf="!breakLines" class="form-element-content"><ng-content></ng-content></div>
    <div
      *ngFor="let value of _values; let i = index; let length = count"
      [matTooltip]="
        value?.value
          ? value.value + ' (' + value.additionalTooltipText + ')'
          : hideTextOverflow
            ? value
            : null
      "
      [ngClass]="{
        value: value,
        'value--overflow-hidden': hideTextOverflow,
        'slash-separated': slashSeparatedValues,
      }"
      class="value-wrapper">
      <p class="content-text">
        <span class="content-text-value body-l">{{ value.value ? value.value : value }}</span>
        <span *ngIf="i + 1 < length && length > 1 && slashSeparatedValues" class="slash-separator">
          /
        </span>
      </p>
    </div>
    <div *ngIf="mandatory && _values.length === 0">
      <p class="content-text">-</p>
    </div>

    <div *ngFor="let value of valuesWithLink" class="value-with-link">
      <a (click)="navigateRoute(value)">{{ value.value }}</a>
    </div>

    <div
      (click)="iconClick()"
      *ngIf="(iconIdentifier || iconText) && !showWaitIcon"
      [matTooltip]="iconTooltip"
      class="icon-wrapper">
      <eop-icon
        *ngIf="iconIdentifier"
        [color]="iconTextColor"
        [identifier]="iconIdentifier"
        [size]="iconSize"
        [style.cursor]="disabled ? 'default' : 'pointer'"
        [weight]="iconWeight"
        class="icon"></eop-icon>

      <div *ngIf="iconText" [ngClass]="{ disabled: disabled }" class="icon-text">
        {{ iconText }}
      </div>
    </div>

    <eop-chip
      *ngIf="chipValue"
      [chipColor]="chipColor"
      [emphasized]="chipEmphasized"
      [matTooltipPosition]="'right'"
      [matTooltip]="chipTooltipText"
      [text]="chipValue">
    </eop-chip>
  </div>

  <div class="separation-line"></div>

  <div *ngIf="footerText || footerIconIdentifier" class="footer-content">
    <eop-icon
      *ngIf="footerIconIdentifier"
      [color]="footerIconColor"
      [identifier]="footerIconIdentifier"
      [vaylensFont]="true"
      class="footer-icon"></eop-icon>
    <span *ngIf="footerText" class="footer-text body-s">{{ footerText }}</span>
  </div>

  <div *ngIf="showWaitIcon">
    <spinner></spinner>
  </div>
</div>
